import { useEffect, useState } from "react";
import axios from "src/utils/axios";

// 2026-10-24 · Acceso a Admin › Redes sociales: solo Administrador y con el email
// en la lista del API (`GET api/admin/social/access` → { allowed }). Una consulta
// por sesión de pestaña (menú y ruta comparten la respuesta).

let cached = null; // Promise<{ allowed, error }>
let cachedKey; // usuario de la respuesta en caché (otro login → se vuelve a preguntar)

export function fetchSocialAccess({ force = false, key } = {}) {
  if (!cached || force || (key !== undefined && key !== cachedKey)) {
    if (key !== undefined) cachedKey = key;
    cached = axios
      .get("admin/social/access")
      .then((res) => ({ allowed: res?.data?.allowed === true, error: null }))
      .catch((err) => {
        // Sin respuesta (red caída/timeout) → error reintentable; cualquier
        // respuesta del API (403, 401, …) → sin acceso.
        const network = err === undefined || err?.isNetworkError === true;
        if (network) cached = null;
        return { allowed: false, error: network ? "No se pudo comprobar el acceso." : null };
      });
  }
  return cached;
}

export function resetSocialAccessCache() {
  cached = null;
  cachedKey = undefined;
}

/**
 * { loading, allowed, error, retry }. Con `enabled=false` no consulta (otros roles).
 * `key` (p. ej. el email) invalida la caché si cambia el usuario.
 */
export default function useSocialAccess(enabled = true, key) {
  const [state, setState] = useState({ loading: enabled, allowed: false, error: null });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setState({ loading: false, allowed: false, error: null });
      return undefined;
    }
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    fetchSocialAccess({ force: attempt > 0, key }).then((r) => {
      if (alive) setState({ loading: false, allowed: r.allowed, error: r.error });
    });
    return () => {
      alive = false;
    };
  }, [enabled, attempt, key]);

  return { ...state, retry: () => setAttempt((n) => n + 1) };
}
